import type { CampaignChannelKind, WhatsAppChannel } from '@workspace/types';

export function contactoChannelsForInstance<
  T extends Pick<WhatsAppChannel, 'purpose' | 'status' | 'instanceId'>,
>(channels: T[], instanceId: string): T[] {
  if (!instanceId) {
    return [];
  }
  return channels.filter(
    channel =>
      channel.purpose === 'CONTACTO' &&
      channel.status === 'ACTIVE' &&
      channel.instanceId === instanceId,
  );
}

export function pickChannelId(channels: Array<{ id: string }>, current: string): string {
  if (channels.some(channel => channel.id === current)) {
    return current;
  }
  return channels[0]?.id ?? '';
}

export function canSaveNoticeDraft(input: {
  instanceId: string;
  channelKind: CampaignChannelKind;
  whatsAppChannelId: string;
  whatsAppTemplateName: string;
  messageTemplateId: string;
}): boolean {
  if (!input.instanceId) {
    return false;
  }
  if (input.channelKind === 'WHATSAPP') {
    return Boolean(input.whatsAppChannelId && input.whatsAppTemplateName.trim());
  }
  return Boolean(input.messageTemplateId);
}

export function noticeDraftBlockReason(input: {
  channelKind: CampaignChannelKind;
  whatsAppChannelId: string;
}): string {
  if (input.channelKind !== 'WHATSAPP') {
    return 'Elegi una plantilla';
  }
  if (input.whatsAppChannelId) {
    return 'Elegi una plantilla de WhatsApp';
  }
  return 'No hay un canal de WhatsApp de contacto activo en esta instancia.';
}
